import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Store/StoreDirections/storeDirections.container"
    ).then((module) => ({
        default: module.StoreDirections
    }))
);
